module.exports = __webpack_public_path__ + "img/logo.348593ca.png";